import type { CustomEventsContext } from '../types'

export const TIMEOUT = 10 * 6 * 1000

export default function (this: CustomEventsContext) {
  return this.sendEventWithCallback('oauth.fb', {}, TIMEOUT)
}
